define((require) => {
    "use strict";

    var ShapeWidgetModel = require("shared/ui/experience/widgets/shapeWidget/ShapeWidgetModel");

    /**
     * @class {ShapeWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return ShapeWidgetModel.mixin("ShapeWidgetModelEditorMixin", {
        /**
         * Returns self description string
         *
         * @return {string} The self description
         */
        _getSelfDescription: function() {
            return `Shape: ${this.get("backgroundColor")}`;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/shapeWidget/ShapeWidgetModelEditorMixin.js